/**
 * The quarter-turn a sample's images are displayed at.
 *
 * Scans come off the scanner portrait; both the viewer and the thumbnails turn
 * them a quarter-turn so they read as landscape. `Sample.rotateClockwise`
 * decides the direction — positive is clockwise for OSD and for CSS alike.
 */
export const DEFAULT_ROTATION = -90;

export function sampleRotation(rotateClockwise?: boolean): number {
    return rotateClockwise ? 90 : DEFAULT_ROTATION;
}
